/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IPOSState } from '../../../types';
import { POS } from './types';

const initialState: IPOSState | null = null;

export const posReducer: Reducer<IPOSState | null> = (state = initialState, action) => {
  switch (action.type) {
    case POS.GET_POS_CATEGORIES_SUCCESS: {
      return { ...state, ...action.payload };
    }
    case POS.GET_POS_EMPLOYEES_SUCCESS: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};
